module.exports = __webpack_public_path__ + "static/drumster-extraimg3@2x-min-c774ae2b7502eb2b6dba18c879e5f9ea.png";